import * as React from "react";
import { forwardRef } from "react";
const SvgIconsCheck = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("path", { d: "M0 0h24v24H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M19.293 5.793a1 1 0 0 1 1.497 1.32l-.083.094-11 11a1 1 0 0 1-1.32.083l-.094-.083-5-5a1 1 0 0 1 1.32-1.497l.094.083L9 16.085 19.293 5.793z", fill: "#111827", fillRule: "nonzero" })));
const ForwardRef = forwardRef(SvgIconsCheck);
export default ForwardRef;
